import { ClientRoles, getSessionStorage } from '@gbs-monorepo-packages/common';

import { AuthStorageKey } from '../constants/Storage';
import { type IUserDTO } from '../services/auth';

type IUser = Partial<Pick<IUserDTO, 'permissions' | 'roles'>>;

interface IValidateUserPermissionsParams {
  user: IUser;
  permissions?: string[];
  roles?: string[];
}

export const validateUserPermissions = ({
  user,
  permissions = [],
  roles = [],
}: IValidateUserPermissionsParams): boolean => {
  const { permissions: userPermissions = [], roles: userRoles = [] } = user;

  const isAdminViewingAsClient =
    getSessionStorage<boolean>(AuthStorageKey.IS_ADMIN_VIEWING_AS_CLIENT) ??
    false;

  let effectiveUserRoles = userRoles;

  if (isAdminViewingAsClient) {
    effectiveUserRoles = ClientRoles;
  }

  if (permissions.length) {
    if (!userPermissions.length) {
      return false;
    }

    const hasAllPermissions = permissions.every((permission) => {
      return userPermissions.includes(permission);
    });

    if (!hasAllPermissions) {
      return false;
    }
  }

  if (roles.length) {
    if (!effectiveUserRoles.length) {
      return false;
    }

    const hasSomeRole = roles.some((role) => {
      return effectiveUserRoles.includes(role);
    });

    if (!hasSomeRole) {
      return false;
    }
  }

  return true;
};
